import { Box } from '@mui/material';
import React, { FC } from 'react';

interface EmailsListProps {
  emails: string[];
}

const EmailsList: FC<EmailsListProps> = ({ emails }) => {
  return (
    <>
      {emails.map((email) => (
        <Box key={email} marginBottom={2}>
          {email}
        </Box>
      ))}
    </>
  );
};

export default EmailsList;
